import { useState, useEffect } from 'react';
import NavBar from '../../components/NavBar/NavBar';
import Heading from '../../components/Heading/Heading';
import lang from '../Auth/languages';
import Select from 'react-select';
import { DonorDetailsAPI, UpdateDonorDetailsAPI } from '../../api/apiHandler';
import Swal from 'sweetalert2';

let style = { color: 'black' };

function Setting() {
    const [languages, setLanguages] = useState([]);
    const [selectedLang, setSelectedLang] = useState("en");
    let langData = {}

    useEffect(() => {
        getDonordetails()
        setLang()
    }, [])


    const setLang = () => {
        langData = Object.entries(lang).map(([key, value]) => ({
            value: key,
            label: value
        }));
        setLanguages(langData);
    }

    
    const getDonordetails = async () => {
        const response = await DonorDetailsAPI();
        if(response.data.code == 1){
            let storedLang = response.data.data.language
            setSelectedLang({ label: lang[storedLang], value: storedLang})
        }else{
            selectedLang('en')
        }
    } 

    const handleSubmit = async (e) => {
          e.preventDefault();
        const payload = {
            ['language']: selectedLang.value,
        };
        const response = await UpdateDonorDetailsAPI(payload);
        if (response.data.code === '1') {
            Swal.fire({
                icon: 'success',
                title: `Data Updated`,
                showConfirmButton: false,
                timer: 2000
            });
        } else {
        Swal.fire({
            icon: 'error',
            title: `Failed to update data`,
            showConfirmButton: false,
            timer: 2000
        });
    }
};


    return (
        <>
            <NavBar />
            <section className="content home">
                <Heading title="Setting" />
                <div className="container-fluid">
                    <div className="row clearfix">
                        <div className="col-lg-12">
                            <div className="card">
                                <div className="body">
                                    <div className="row">
                                        <div className="details col-md-12">
                                            <form className="col-lg-12" onSubmit={(e) => handleSubmit(e)}>
                                                <div className="form-group form-float">
                                                    <label className="form-label" style={style}>Filed 1</label>
                                                    <div className="form-line">
                                                        <input type='text' className="form-control" required id='opassword' value={"10"} name='opassword' />
                                                    </div>
                                                </div>
                                                <div className="form-group form-float">
                                                    <label className="form-label" style={style}>Filed 2</label>
                                                    <div className="form-line">
                                                        <input type="text" className="form-control" required id='password' value={"12"} name='password' minLength={6} />
                                                    </div>
                                                </div>
                                                <div className="form-group form-float">
                                                    <div className="form-line">
                                                        <Select
                                                            placeholder={"Select language"}
                                                            name="language"
                                                            value={selectedLang}
                                                            onChange={(e) => {
                                                                setSelectedLang({label: e.label , value: e.value});
                                                            }}
                                                            options={languages}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-12">
                                                    <button type="submit" className="btn btn-raised btn-primary waves-effect">Update Setting</button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Setting;